import 'css-chunksrc/client/scenes/projectElementDetailsConfiguration/form/styles.scss';export default {
  "form": "_form_1ot66_1",
  "group": "_group_1ot66_5",
  "row": "_row_1ot66_9",
  "label": "_label_1ot66_19",
  "description": "_description_1ot66_24",
  "roleSelection": "_roleSelection_1ot66_28"
};